import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { DevolutionProjectionModel } from 'src/app/models/preliminaries/devolution-projection';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DevolutionProjectionService {

  private readonly _httpClient = inject(HttpClient);

  createDevolutionProjection(devolutionProjectionModel: DevolutionProjectionModel): Observable<DevolutionProjectionModel> {
    return this._httpClient.post<DevolutionProjectionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.devolutionProjection.CreateAsync}`,
      devolutionProjectionModel
    );
  }

  deleteDevolutionProjection(devolutionProjectionId: number): Observable<DevolutionProjectionModel> {
    const params = new HttpParams().set('devolutionProjectionId', devolutionProjectionId);
    return this._httpClient.delete<DevolutionProjectionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.devolutionProjection.DeleteAsync}`,
      { params: params }
    );
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.devolutionProjection.ExportGeneralConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  getAllDevolutionProjectionsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.devolutionProjection.GetAllDevolutionProjectionsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getDevolutionProjectionById(devolutionProjectionId: number): Observable<DevolutionProjectionModel> {
    const params = new HttpParams().set('devolutionProjectionId', devolutionProjectionId);
    return this._httpClient.get<DevolutionProjectionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.devolutionProjection.GetByIdAsync}`,
      { params: params }
    );
  }

  getClientsForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.devolutionProjection.GetClientsForSelectAsync}`);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.devolutionProjection.GetColumnsForGeneralConsultationAsync}`);
  }

  getCostCenterByBranchForSelect(branchId: number): Observable<Array<any>> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.devolutionProjection.GetCostCentersByBranchForSelectAsync}`,
      { params: params }
    );
  }

  getDevolutionProjectionByKeys(branchId: number, costCenterId: number): Observable<DevolutionProjectionModel> {
    const params = new HttpParams().set('branchId', branchId).set('costCenterId', costCenterId);
    return this._httpClient.get<DevolutionProjectionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.devolutionProjection.GetDevolutionProjectionByKeysAsync}`,
      { params: params }
    );
  }

  getFirstDevolutionProjectionByKeys(branchId: number): Observable<DevolutionProjectionModel> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<DevolutionProjectionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.devolutionProjection.GetFirstDevolutionProjectionByKeysAsync}`,
      { params: params }
    );
  }

  getLastDevolutionProjectionByKeys(branchId: number): Observable<DevolutionProjectionModel> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<DevolutionProjectionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.devolutionProjection.GetLastDevolutionProjectionByKeysAsync}`,
      { params: params }
    );
  }

  getNextDevolutionProjectionByKeys(branchId: number, devolutionProjectionId: number): Observable<DevolutionProjectionModel> {
    const params = new HttpParams().set('branchId', branchId).set('devolutionProjectionId', devolutionProjectionId);
    return this._httpClient.get<DevolutionProjectionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.devolutionProjection.GetNextDevolutionProjectionByKeysAsync}`,
      { params: params }
    );
  }

  getPreviusDevolutionProjectionByKeys(branchId: number, devolutionProjectionId: number): Observable<DevolutionProjectionModel> {
    const params = new HttpParams().set('branchId', branchId).set('devolutionProjectionId', devolutionProjectionId);
    return this._httpClient.get<DevolutionProjectionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.devolutionProjection.GetPreviusDevolutionProjectionByKeysAsync}`,
      { params: params }
    );
  }

  updateDevolutionProjection(devolutionProjectionModel: DevolutionProjectionModel): Observable<DevolutionProjectionModel> {
    return this._httpClient.put<DevolutionProjectionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.devolutionProjection.UpdateAsync}`,
      devolutionProjectionModel
    );
  }
}
